import { z } from "zod";
import { validQuantityPrecision } from "../../../shared/production/quantity";

export const quantityDraftSchema = z.object({
  type: z.enum(["PRODUCTION", "WASTE", "SCRAP"]),
  quantity: z.string().refine((value) => validQuantityPrecision(Number(value))),
  unit: z.string().min(1).max(80),
  expectedFactorToPrimary: z.number().positive().finite(),
  reasonCodeId: z.string().nullable(),
  note: z.string().max(500),
  scrapDisposition: z.enum(["ANIMAL_FEED", "REUSABLE"]).nullable(),
});
export type QuantityWriteDraft = z.infer<typeof quantityDraftSchema>;

export const quantityWriteSchema = z.object({
  idempotencyKey: z.string().uuid(),
  runId: z.string().min(1),
  workOrderNo: z.string(),
  terminalCode: z.string().min(1),
  operatorId: z.string().min(1),
  sessionId: z.string().min(1),
  occurredAt: z.string().datetime(),
  status: z.enum(["UNSENT", "SENDING", "UNCERTAIN", "FAILED"]),
  error: z.string().nullable(),
  attempts: z.number().int().nonnegative().default(0),
  attemptedAt: z.number().finite().nullable().default(null),
  everUncertain: z.boolean().default(false),
  draft: quantityDraftSchema,
});
export type PendingQuantityWrite = z.infer<typeof quantityWriteSchema>;
const storedQueueSchema = z.object({ version: z.literal(1), items: z.array(quantityWriteSchema).max(64) });

export function decodeQuantityQueue(value: string | null): PendingQuantityWrite[] {
  if (!value) return [];
  const parsed: unknown = JSON.parse(value);
  return storedQueueSchema.parse(parsed).items.map((item) => item.status === "SENDING"
    ? { ...item, status: "UNCERTAIN", everUncertain: true, error: "Önceki gönderimin sonucu doğrulanamadı." }
    : item);
}

export function encodeQuantityQueue(items: PendingQuantityWrite[]) {
  return JSON.stringify(storedQueueSchema.parse({ version: 1, items }));
}

export { canRetryQuantityWrite, QUANTITY_ATTEMPT_LEASE_MS, recoverInterruptedWrite, claimQuantityAttempt, quantityAttemptFailed } from "./quantity-write-state";
export type { QuantityWriteIdentity } from "./quantity-write-state";
